import { Box, Button, useTheme } from "@mui/material";
import * as erp_conf from "../../functions/erp-config";
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

const FormAddEditToolbar = ({ handleSave, isSaving, handleCancel, }) => {
	const theme = useTheme();
	
	return (
		<Box ml={2.5} mb={2}>
			<Box display="flex" justifyContent="space-between">
				<Stack direction="row" spacing={2}>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						size={erp_conf.v_button_size}
						startIcon={<DoneAllOutlinedIcon />}
						onClick={handleSave}
						disabled={isSaving}
						sx={{
							boxShadow: theme.shadows[2],
							'&:hover': {
								boxShadow: theme.shadows[4],
								transform: 'translateY(-1px)',
							},
						}}
					>
						Αποθήκευση
					</Button>
					<Button
						variant="outlined"
						color="error"
						size={erp_conf.v_button_size}
						startIcon={<CancelOutlinedIcon />}
						onClick={handleCancel}
						sx={{
							'&:hover': {
								transform: 'translateY(-1px)',
							},
						}}
					>
						Ακύρωση
					</Button>
				</Stack>
			</Box>
		</Box>
	)
}

export default FormAddEditToolbar;
